import PeopleIcon from '@mui/icons-material/People';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import React from 'react';
import Controls from '../../components/Slider/Controls';
import Header from '../../components/Slider/Header';
import SplitSelection from '../../components/SplitSelection';
import NewCompany from './NewCompany';
import NewContact from './NewContact';
import SelectCompany from './SelectCompany';
import SelectContact from './SelectContact';
import When from './When';

const Who = ({onBack, onNext}) => (
  <>
    <Header>Who is the Job For?</Header>
    <SplitSelection
      sections={[
        {
          title: 'Company',
          icon: <RecentActorsIcon/>,
          buttons: [
            {
              label: 'Select An Existing Company',
              onClick: () => onNext({type: SelectCompany.type, id: SelectCompany.type})
            },
            {
              label: 'Create a New Company',
              onClick: () => onNext({type: NewCompany.type, id: NewCompany.type})
            },
          ]
        },
        {
          title: 'Contact',
          icon: <PeopleIcon/>,
          buttons: [
            {
              label: 'Select An Existing Contact',
              onClick: () => onNext({type: SelectContact.type, id: SelectContact.type})
            },
            {
              label: 'Create a New Contact',
              onClick: () => onNext({type: NewContact.type, id: NewContact.type})
            },
          ]
        }
      ]}
    />
    <Controls onBack={() => onBack(
      {type: When.type, id: When.type},
      {selectedAllocation: null}
    )}/>
  </>
);

Who.type = 'WHO';

export default Who;
